'use strict';

module.exports = {
    getNumberOfPassengers: function() {
        var numberPassengers = Odigeo.Utils.parseJson(Odigeo.Session.get('booking_pax_list')) || [];
        return numberPassengers.length;
    },
};
